import { Button } from "@/components/ui/button";
import { modalStore } from "@/lib/stores/modals";
import { useStore } from "@tanstack/react-store";
import { useEffect } from "react";
import { Dialog, DialogContent } from "~/components/ui/dialog";

const IS_ADULT_CHECKED = "IS_ADULT_CHECKED";

export default function AdultModal() {
	const { adultModalOpen } = useStore(modalStore);

	useEffect(() => {
		const isAdultChecked = localStorage.getItem(IS_ADULT_CHECKED);
		if (!isAdultChecked) {
			modalStore.setAdultModalOpen(true);
		}
	}, []);

	return (
		<div>
			<Dialog
				open={adultModalOpen}
				onOpenChange={(open) => modalStore.setAdultModalOpen(open)}
			>
				<DialogContent
					className="md:!w-[540px] md:!max-w-[540px] md:max-h-[658px] flex flex-col items-center justify-center px-18! pt-10.5! pb-8!"
					hideCloseBtn
					hideOverlayClose
				>
					<div className=" wrap-anywhere flex flex-col items-center justify-center">
						<img
							src={"/assets/images/adult.svg"}
							alt="adult"
							className="-ml-6"
						/>
						<div className="text-t1 text-sm leading-6 mt-8">
							Our website may contain <span className="text-main1">18+</span> or
							adult content. By clicking the "I am over 18" button, you
							represent that you have fully understood and agree to comply with
							our{" "}
							<span
								className="text-c7 cursor-pointer"
								onClick={() => {
									modalStore.setPPModalOpen(true);
								}}
							>
								Privacy Policy and Terms & Conditions
							</span>
							.<p>Have you reached the age of 18?</p>
						</div>
						<div className="flex gap-1.5 mt-4">
							<Button
								onClick={() => {
									try {
										window.close();
									} finally {
										window.location.href = "about:blank";
									}
								}}
								className="w-[175px] h-10 rounded-full text-sm bg-bg2 text-t1 cursor-pointer hover:bg-bg4 dark:hover:bg-main1 dark:hover:text-w1"
							>
								No, i’m not
							</Button>
							<Button
								onClick={() => {
									localStorage.setItem(IS_ADULT_CHECKED, "true");
									modalStore.setAdultModalOpen(false);
								}}
								className="w-[175px] h-10 rounded-full text-sm bg-c1 text-t1 cursor-pointer hover:bg-main1 hover:text-w1"
							>
								Yes, i am over 18
							</Button>
						</div>
					</div>
				</DialogContent>
			</Dialog>
		</div>
	);
}
